import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RiCheckboxCircleLine,
  RiDownloadLine,
  RiMailLine,
  RiWhatsappLine,
  RiHome2Line,
  RiFileTextLine,
} from "react-icons/ri";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    if (!state?.paymentDetails) {
      navigate("/billing");
      return;
    }
    // Hide confetti after 5 seconds
    const timer = setTimeout(() => setShowConfetti(false), 5000);
    return () => clearTimeout(timer);
  }, [state, navigate]);

  const paymentDetails = state?.paymentDetails || {
    transactionId: "TXN" + Date.now(),
    amount: 2499.99,
    date: new Date().toISOString(),
    paymentMethod: "Credit Card",
    invoiceNumber: "INV-2024-001",
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6 py-12">
      {showConfetti && (
        <div className="fixed inset-0 pointer-events-none"></div>
      )}

      <div className="text-center">
        <RiCheckboxCircleLine className="w-20 h-20 text-green-500 mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-gray-900">
          Payment Successful!
        </h1>
        <p className="text-gray-600 mt-2">
          Thank you for your payment. Your transaction has been completed.
        </p>
      </div>

      <div className="card space-y-4">
        <div className="flex justify-between py-3 border-b">
          <span className="text-gray-600">Transaction ID</span>
          <span className="font-medium">{paymentDetails.transactionId}</span>
        </div>
        <div className="flex justify-between py-3 border-b">
          <span className="text-gray-600">Amount Paid</span>
          <span className="font-medium">
            ${paymentDetails.amount.toFixed(2)}
          </span>
        </div>
        <div className="flex justify-between py-3 border-b">
          <span className="text-gray-600">Payment Date</span>
          <span className="font-medium">
            {new Date(paymentDetails.date).toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between py-3 border-b">
          <span className="text-gray-600">Payment Method</span>
          <span className="font-medium">{paymentDetails.paymentMethod}</span>
        </div>
        <div className="flex justify-between py-3">
          <span className="text-gray-600">Invoice Number</span>
          <span className="font-medium">{paymentDetails.invoiceNumber}</span>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <button className="btn btn-secondary flex items-center justify-center gap-2">
          <RiDownloadLine className="w-5 h-5" />
          Download Receipt
        </button>
        <button className="btn btn-secondary flex items-center justify-center gap-2">
          <RiMailLine className="w-5 h-5" />
          Email Receipt
        </button>
      </div>

      <div className="flex justify-center gap-4 pt-6">
        <button
          onClick={() => navigate("/billing")}
          className="btn btn-primary flex items-center gap-2"
        >
          <RiHome2Line className="w-5 h-5" />
          Back to Dashboard
        </button>
        <button
          onClick={() => navigate("/billing/invoice-history")}
          className="btn btn-secondary flex items-center gap-2"
        >
          <RiFileTextLine className="w-5 h-5" />
          View All Invoices
        </button>
      </div>

      <div className="text-center text-sm text-gray-500">
        <p>
          A confirmation email has been sent to your registered email address.
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
